export const STATUS_LOADING = {
  load: 'LOAD',
  done: 'DONE',
  error: 'ERROR'
} as const;

export type IStatusLoading = typeof STATUS_LOADING;
export type StatusLoadingKeys = keyof IStatusLoading;
export type StatusLoading = typeof STATUS_LOADING[StatusLoadingKeys];
